import { render, staticRenderFns } from "./BookingsTable.vue?vue&type=template&id=6fa2e988&scoped=true"
import script from "./BookingsTable.vue?vue&type=script&lang=js"
export * from "./BookingsTable.vue?vue&type=script&lang=js"
import style0 from "./BookingsTable.vue?vue&type=style&index=0&id=6fa2e988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2e988",
  null
  
)

export default component.exports